import { render, staticRenderFns } from "./Face.vue?vue&type=template&id=78b50cfe&scoped=true"
import script from "./Face.vue?vue&type=script&lang=js"
export * from "./Face.vue?vue&type=script&lang=js"
import style0 from "./scss/face.scss?vue&type=style&index=0&id=78b50cfe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b50cfe",
  null
  
)

export default component.exports